module.exports = __webpack_public_path__ + "static/media/scrollLeft1.ae8e1934.png";